<div
    class="d-flex w-100 ranks-scorecard-widget"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="cmps-scorecard-widget--cmps-container"
        [collapsable]="false"
        variant="colored"
    >
        <cmps-container-header
            class="text-center"
            [headerColour]="headerColour"
            [textColour]="headerTextColour"
        >
            {{ _widget.name }}
        </cmps-container-header>
        <cmps-container-content>
            <cmps-wait-status
                [srStatus]="'Loading ' + _widget.name"
                *ngIf="_isLoadingData | async"
            ></cmps-wait-status>
            <div
                class="no-data w-100 p-2 d-flex justify-content-center"
                *ngIf="!(_isLoadingData | async) && _ranks?.length === 0"
            >
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="w-100"
                *ngIf="!(_isLoadingData | async) && _ranks?.length !== 0"
            >
                <div
                    class="sc-widget-content-row"
                    *ngFor="let rank of _ranks"
                >
                    <div class="sc-widget-grid-title">{{ rank.rankName }}</div>
                    <div class="sc-widget-grid-value">
                        {{ rank.rankResultScorecardPeriod }}/{{
                            rank.totalPositionsScorecardPeriod
                        }}
                    </div>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
